// extracted by mini-css-extract-plugin
module.exports = {"container":"ActiveSubscriptionsSummary_container__8XMqK"};